import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "pb-10 pb-lg-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark col-md-8" }, "Team Members", -1)
const _hoisted_5 = { class: "fv-row mb-10 my-5" }
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_10 = ["onInput"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_remove"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "Allowed file types: png, jpg, jpeg.", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_14 = { class: "fv-row mb-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Job Title"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_16 = { class: "fv-row mb-10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "LinkedIn Profile Url"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_18 = { class: "fv-row mb-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Single-Line Bio or Introduction"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_20 = { class: "row float-end" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  style: {"color":"red"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "javascript:void(0)",
          class: "btn col-md-4",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addTeamMember && _ctx.addTeamMember(...args))),
          style: {"color":"#ffffff","background-color":"#236db5"}
        }, " Add Another Member ")
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembers, (member, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `team-member-${index}`
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "image-input image-input-outline",
                "data-kt-image-input": "true",
                style: _normalizeStyle(`background-image: ${
                _ctx.teamMembers[index].profilePicture
                  ? `url(${_ctx.teamMembers[index].profilePicture})`
                  : 'url(media/avatars/blank.png)'
              }`)
              }, [
                _createElementVNode("div", {
                  ref_for: true,
                  ref: "profilePictureRef",
                  class: "image-input-wrapper w-125px h-125px",
                  style: _normalizeStyle(`background-image: ${
                  _ctx.teamMembers[index].profilePicture
                    ? `url(${_ctx.teamMembers[index].profilePicture})`
                    : 'url(media/avatars/blank.png)'
                }`)
                }, null, 4),
                _createElementVNode("label", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("input", {
                    onInput: ($event: any) => (_ctx.fileAdded(index, $event)),
                    type: "file",
                    name: "avatar",
                    accept: ".png, .jpg, .jpeg"
                  }, null, 40, _hoisted_10),
                  _hoisted_11
                ])
              ], 4),
              _hoisted_12
            ])
          ]),
          _hoisted_13,
          _createVNode(_component_Field, {
            onBlur: _ctx.createDraft,
            modelValue: _ctx.teamMembers[index].name,
            "onUpdate:modelValue": ($event: any) => ((_ctx.teamMembers[index].name) = $event),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fieldChanged($event))),
            name: `team-member-name-${index}`,
            class: "form-control form-control-lg form-control-solid"
          }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue", "name"]),
          _withDirectives(_createVNode(_component_ErrorMessage, {
            name: `team-member-name-${index}`,
            class: "fv-plugins-message-container invalid-feedback"
          }, null, 8, ["name"]), [
            [_vShow, _ctx.touched]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_Field, {
            onBlur: _ctx.createDraft,
            modelValue: _ctx.teamMembers[index].jobTitle,
            "onUpdate:modelValue": ($event: any) => ((_ctx.teamMembers[index].jobTitle) = $event),
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fieldChanged($event))),
            name: `team-member-jobTitle-${index}`,
            class: "form-control form-control-lg form-control-solid"
          }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue", "name"]),
          _withDirectives(_createVNode(_component_ErrorMessage, {
            name: `team-member-jobTitle-${index}`,
            class: "fv-plugins-message-container invalid-feedback"
          }, null, 8, ["name"]), [
            [_vShow, _ctx.touched]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_Field, {
            onBlur: _ctx.createDraft,
            modelValue: _ctx.teamMembers[index].linkedInProfileUrl,
            "onUpdate:modelValue": ($event: any) => ((_ctx.teamMembers[index].linkedInProfileUrl) = $event),
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fieldChanged($event))),
            type: "text",
            name: `team-member-linkedInProfileUrl-${index}`,
            class: "form-control form-control-lg form-control-solid",
            rows: "3"
          }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue", "name"]),
          _withDirectives(_createVNode(_component_ErrorMessage, {
            name: `team-member-linkedInProfileUrl-${index}`,
            class: "fv-plugins-message-container invalid-feedback"
          }, null, 8, ["name"]), [
            [_vShow, _ctx.touched]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_Field, {
            onBlur: _ctx.createDraft,
            modelValue: _ctx.teamMembers[index].introduction,
            "onUpdate:modelValue": ($event: any) => ((_ctx.teamMembers[index].introduction) = $event),
            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fieldChanged($event))),
            type: "text",
            name: `team-member-introduction-${index}`,
            class: "form-control form-control-lg form-control-solid",
            rows: "3"
          }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue", "name"]),
          _withDirectives(_createVNode(_component_ErrorMessage, {
            name: `team-member-introduction-${index}`,
            class: "fv-plugins-message-container invalid-feedback"
          }, null, 8, ["name"]), [
            [_vShow, _ctx.touched]
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("i", {
            style: {"cursor":"pointer"},
            class: "fas fa-trash",
            onClick: ($event: any) => (_ctx.removeTeamMember(index))
          }, null, 8, _hoisted_21)
        ])
      ]))
    }), 128)),
    (_ctx.isAnyTeamMemberAdded)
      ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Kindly add a Team Member to continue "))
      : _createCommentVNode("", true)
  ]))
}